const language = window.__LOCALE__ || 'en';

export function getLink(name: string): string {
  const baseDomain = 'editorx.com';
  const wixBaseDomain = 'https://www.wix.com';
  let baseUrl = 'https://www.' + baseDomain;

  // Commented until we would have different languages domains
  // let baseUrl =
  //   language === 'en'
  //     ? '//www.' + baseDomain
  //     : '//' + language + '.' + baseDomain;

  if (!baseUrl.match(/\/$/)) {
    baseUrl += '/';
  }

  const links: { [index: string]: string } = {
    editorX: baseUrl,
    wix: wixBaseDomain,
    homePage: '/',
    helpCenter: 'https://support.wix.com/en/editor-x-beta/about-editor-x-7952617',
    mySites:
      wixBaseDomain + '/account/sites?referralAdditionalInfo=account-manager',
    editorXFeatures: wixBaseDomain + '/editorx/features',
    editorXTemplates: wixBaseDomain + '/editorx/templates',
    clearCookies:
      'https://support.wix.com/en/article/clearing-wix-cookies-from-your-browser',
    learnMorePermissions:
      wixBaseDomain +
      'support/html5/my-sites/site-actions/kb/site-contributors',
  };

  return links[name] || links.wix;
}
